import Header from '@trinity/chat-components/components/Modal/Header.js';
import type { ModalProps } from '@trinity/chat-components/components/Modal/Modal.js';
import { Modal } from '@trinity/chat-components/components/Modal/Modal.js';
import type { ConferenceTagSummaryItem, TranscribeRT } from '@/types';
import { TagSummaryCitationsTable } from './CitationsTable';
import styles from './style/Modal.Citations.module.css';

type Props = {
  hideSourceColumn?: boolean;
  items: (TranscribeRT.TaggedMoment & Partial<ICallId>)[];
  summaryItem: ConferenceTagSummaryItem;
} & IProjectId & Pick<ModalProps, 'open' | 'onClose'>;

export const TagSummaryCitationsModal = ({
  hideSourceColumn = false,
  items,
  open,
  onClose,
  summaryItem,
  projectId,
}: Props) => {

  const title = `${summaryItem.tag.name} Citations`;

  return (
    <Modal
      className={styles.root}
      open={open}
      onClose={onClose}>

      <Header text={title} />

      <div className={styles.body}>
        <TagSummaryCitationsTable
          projectId={projectId}
          hideSourceColumn={hideSourceColumn}
          items={items} />
      </div>

    </Modal>
  );
};